export const validateSession = () => {
  const expire = localStorage.getItem('expire');
  if (!expire || expire < Date.now() || !localStorage.getItem('access_token')){
    console.log('Sesión expirada')
    return false
  } 
  return true
}